import { CircularProgress } from "@mui/material";
import React from "react";
import MultiSelectDropdown from "../../../Atoms/DropDowns/MultiSelectDropdown";
import { useAgent } from "../../../../contexts/AgentsContext";

const AgentBusinessFuncSec = () => {
  const {
    ongoingAgentData,
    updateOngoingAgentDataL3,
    isLoadingDropdownFields,
    lookUpValues,
  } = useAgent();

  return (
    <>
      <label className="mas-form-label-regular mb-2">
        Applicable Business Function
      </label>
      <div className="d-flex align-items-center">
        <MultiSelectDropdown
          selectValues={
            lookUpValues?.bFs?.map((item) => ({
              value: item,
              label: item,
            })) || []
          }
          values={
            ongoingAgentData?.classifications?.[0]?.business_function || []
          }
          handleOnChange={(values) =>
            updateOngoingAgentDataL3("business_function", values)
          }
          dropdownLabel="Select/Type to Search"
          placement="top"
          clsNames="mas-multiselect-dd-primary mas-multi-dd-2"
          disabled={isLoadingDropdownFields?.bFs}
        />

        {isLoadingDropdownFields?.bFs && (
          <CircularProgress
            style={{
              width: "15px",
              height: "15px",
              opacity: 0.8,
              marginLeft: "5px",
            }}
          />
        )}
      </div>
    </>
  );
};

export default AgentBusinessFuncSec;
